<div class="site-footer pb-md-0" *ngIf="!hideFooter"  [style.background-color]="background" [style.color]="foreground">
    <div class="container">
        <div class="site-footer__widgets">
            <div class="row">
                <div class="col-12 col-md-6 col-lg-4">
                    <div *ngFor="let page of staticPages|keyvalue">
                        <app-footer-links [header]="page.key" [links]="page.value"></app-footer-links>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <app-footer-contacts></app-footer-contacts>
                    <div *ngIf="siteCompany" class="registrations">
                        <div *ngIf="siteCompany.crNumber">{{"cr"|translate}} {{siteCompany?.crNumber}}</div>
                        <div *ngIf="siteCompany.vatCertificate">{{"vatr"|translate}} {{siteCompany?.vatCertificate}}
                        </div>
                    </div>

                </div>
                <!--
                <div class="col-6 col-md-3 col-lg-2">
                    <app-footer-links header="My Account" [links]="[
                        {label: 'Store Location', url: ''},
                        {label: 'Order History',  url: ''},
                        {label: 'Wish List',      url: ''},
                        {label:'Become a Vendor',url:'/apply-for-vendor'}
                    ]"></app-footer-links>
                </div>
                -->
                <div class="col-12 col-md-12 col-lg-4">

                    <app-footer-newsletter class="site-footer__widget"></app-footer-newsletter>

                    <div class="register-undertext" *ngIf="!siteService.siteSetting.companyId">
                        {{"register_now_footer"|translate}}
                    </div>

                    <div class="store-link-container">
                        <div class="appstores-link" *ngIf="siteService.siteSetting.apps?.iphone">
                            <a class="link" target="_blank" [href]="siteService.siteSetting.apps.iphone">
                                <mat-icon svgIcon="app-store"></mat-icon>
                            </a>
                        </div>
                        <div class="playstores-link" *ngIf="siteService.siteSetting.apps?.android">
                            <a class="link" target="_blank" [href]="siteService.siteSetting.apps.android">
                                <mat-icon svgIcon="google-play"></mat-icon>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--
        <div class="site-footer__bottom">
            <div class="site-footer__copyright">
                Powered by <a href="https://angular.io/" target="_blank">Angular</a> — Design by <a [href]="theme.author.profile_url" target="_blank">{{ theme.author.name }}</a>
            </div>
            <div class="site-footer__payments">
                <img src="assets/images/payments.png" alt="">
            </div>
        </div>
        -->
    </div>
    <!-- <app-totop></app-totop> -->
</div>
<!-- TODO: Add links to and conditions to social media -->
<div class="bg-white p-2 footer__footer">
    <div class="container flex flex-row  gap-1 justify-between text-sm items-center">
        <div>{{"payment_methods"|translate}} <img class="ms-4 h-4" src="assets/svg/visa.svg"> <img class="ms-4 h-4" src="assets/svg/mastercard.svg"></div>
        <div>© {{thisYear}} {{"all_rights_reserved"|translate}} <h1 class="meta-header">{{siteService.siteSetting.name}}</h1></div>
        <div class="h-4 flex flex-row items-center"><span class="me-3">{{"follow_us"|translate}}:</span>
            <a class="h-4" *ngIf="siteService.siteSetting?.socialMedia?.instagram?.active&&siteService.siteSetting?.socialMedia?.instagram?.link" [href]="siteService.siteSetting.socialMedia.instagram.link"> <mat-icon [inline]="true" svgIcon="instagram"></mat-icon></a>
            <a class="h-4" *ngIf="siteService.siteSetting?.socialMedia?.twitter?.active&&siteService.siteSetting?.socialMedia?.twitter?.link" [href]="siteService.siteSetting.socialMedia.twitter.link"><mat-icon class="ms-3" [inline]="true" svgIcon="twitter"></mat-icon></a>
            <!-- <mat-icon>indeterminate_check_box</mat-icon> -->
        </div>
    </div>
</div>
